
import { defineComponent, Ref, ref } from "vue";

import i18n, { locales, loadMessages } from "@/plugins/i18n";

export default defineComponent({
	setup() {
		const selectedLocale: Ref<string> = ref("en");

		const changeLocale = async () => {
			await loadMessages(selectedLocale.value);
			i18n.global.locale = selectedLocale.value;
		};

		return {
			locales,
			selectedLocale,
			changeLocale
		};
	}
});
